module.exports = __webpack_public_path__ + "img/linkedin-mob.b88c61e3.svg";